import { createGlobalStyle } from 'styled-components';
import { theme } from './themes';

import Reset from './includes/reset';
import Variables from './includes/variables';
import template from './includes/template';
import Base from './includes/base';
import Text from './includes/text';
import Helpers from './includes/helpers';

export const GlobalStyle = createGlobalStyle`
  ${Reset}
  ${Variables}
  ${template}
  ${Base}
  ${Text}
  ${Helpers}
`;
